module.exports = __webpack_public_path__ + "img/legal-document-control.66ee6e37.png";